import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip, Spin } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import taxpayer from '../../Actions/taxpayer';
import { stringToQuantityWithCommas, getTaxPayer, checkIfVolumeIsBeingCalculated } from '../../helpers';
import { Link } from 'react-router-dom';
const { getTaxpayerVolumeData } = taxpayer.actions;

class TaxPayerVolume extends Component {

    constructor(props) {
        super(props);
        this.checkIfVolumeIsBeingCalculated = this.checkIfVolumeIsBeingCalculated.bind(this);
        this.getTextFromDocumentType = this.getTextFromDocumentType.bind(this);
    }

    componentDidMount() {
        this.props.getTaxpayerVolumeData();
    }

	render() {
        let { taxpayerVolume, taxId, documents } = this.props;
        
        let taxIdFound = getTaxPayer(taxpayerVolume,taxId);
		return ( 
			<div className="taxpayer-info-container">
                { taxIdFound ?
                    this.checkIfVolumeIsBeingCalculated(taxIdFound.createdDate, taxIdFound.updatedDate) ?
                        <span className="blue-text"> 
                            Estimado Mensual:&nbsp;
                            { documents.toLowerCase() === 'emision' ?
                                stringToQuantityWithCommas(taxIdFound.issuingVolumeMonthly) 
                            :
                                stringToQuantityWithCommas(taxIdFound.receivingVolumeMonthly) 
                            }
                            &nbsp;XML
                        </span>
                    :
                        <span className="blue-text"> Se está calculando el volumen de tus {this.getTextFromDocumentType(documents)} </span>
                :
                <Link className="blue-text" to="/settings">
                    Calcular tu estimado
                    <Tooltip
                        placement="bottom"
                        title="Genera una solicitud para conocer el promedio mensual de facturas recibidas y emitidas">
                        <InfoCircleOutlined/>
                    </Tooltip>
                </Link>
                }
                {
					this.props.isLoadingTaxpayer &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
					</div>
				}
			</div>
		)
    }
    
    checkIfVolumeIsBeingCalculated(startDate, updateDate) {
        return checkIfVolumeIsBeingCalculated(startDate,updateDate); 
    }

    getTextFromDocumentType(document){
        switch(document.toLowerCase()){
            case 'emision':
                return 'facturas emitidas';
            case "recepcion":
                return 'facturas recibidas';
            default:
                return "";
        }
    }
}

const mapStateToProps = state => {    
    let taxpayerLoading = state._genericComponents.loading.find('loadingTaxpayer');
	return {
        taxpayerVolume: state.taxpayer.taxpayerVolume,
        isLoadingTaxpayer: taxpayerLoading ? taxpayerLoading.isLoading : false,
	};

};

const mapDispatchToProps = dispatch => {
	return {
        getTaxpayerVolumeData() {
			dispatch(getTaxpayerVolumeData())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxPayerVolume);
